import type { ComponentType, SVGProps } from 'react';
import {
  Archive,
  ArrowRight,
  Camera,
  Check,
  CheckCircle2,
  CircleAlert,
  Copy,
  Ellipsis,
  ExternalLink,
  FileText,
  Filter,
  Lightbulb,
  Link,
  Link2Off,
  LogOut,
  Minus,
  Pencil,
  Pin,
  Play,
  Plus,
  RefreshCw,
  RotateCcw,
  Save,
  Search,
  Shield,
  ShieldAlert,
  Sparkles,
  Trash2,
  Unplug,
  X,
  ChevronDown,
  ChevronUp,
  Eye,
  Heart,
  Library,
  MessageCircle,
  Maximize2,
  Power,
  Share2,
  SlidersHorizontal,
  Timer,
  BadgeCheck,
  Bookmark,
} from 'lucide-react';
import { cn } from '../lib/utils';

const iconByName: Record<string, ComponentType<SVGProps<SVGSVGElement>>> = {
  add: Plus,
  archive: Archive,
  arrow_forward: ArrowRight,
  article: FileText,
  auto_awesome: Sparkles,
  check: Check,
  check_circle: CheckCircle2,
  close: X,
  content_copy: Copy,
  delete: Trash2,
  delete_sweep: Trash2,
  edit: Pencil,
  error: CircleAlert,
  expand_more: ChevronDown,
  filter_alt: Filter,
  gpp_bad: ShieldAlert,
  link: Link,
  link_off: Link2Off,
  logout: LogOut,
  more_horiz: Ellipsis,
  open_in_new: ExternalLink,
  open_in_full: Maximize2,
  photo_camera: Camera,
  push_pin: Pin,
  play_arrow: Play,
  published_with_changes: RefreshCw,
  refresh: RefreshCw,
  remove: Minus,
  replay: RotateCcw,
  save: Save,
  search: Search,
  security: Shield,
  settings: Shield,
  sync: RefreshCw,
  tips_and_updates: Lightbulb,
  extension: Unplug,
  verified: BadgeCheck,
  schedule: Timer,
  library_books: Library,
  visibility: Eye,
  expand_less: ChevronUp,
  toggle_on: Play,
  toggle_off: Power,
  chat_bubble: MessageCircle,
  favorite: Heart,
  bookmark: Bookmark,
  share: Share2,
  tune: SlidersHorizontal,
};

export interface PortalIconProps extends SVGProps<SVGSVGElement> {
  name: string;
  size?: number;
}

export function PortalIcon({ name, size, className, style, ...props }: PortalIconProps) {
  const Icon = iconByName[name] ?? CircleAlert;
  return (
    <Icon
      className={cn('portal-icon', className)}
      strokeWidth={1.75}
      aria-hidden="true"
      style={size ? { ...style, width: size, height: size } : style}
      {...props}
    />
  );
}
